import { useIntl } from "react-intl";
import { Popup, Progress, Table } from "semantic-ui-react";
import LegendBar from "../../campaign/common/LegendBar";
import { getColorIndicator, isUndefined } from "../../../libs/common_utils";
import LegendPill from "../../campaign/common/LegendPill";

const PacingRatioPopup = ({ data, nullishCurrencyFormat }) => {
  const intl = useIntl();
  const pacingAt = data?.strategy_pacing_ratio;
  const underspend = data?.strategy_daily_pacing_under_spend;
  const pacingAmount = data?.strategy_pacing_amount;
  const spendYesterday = data?.total_spend_yesterday;
  const HUNDRED_PERCENT = 100;
  const hasPacingAt = pacingAt || pacingAt === 0;
  const isUnderspend = hasPacingAt ? pacingAt < HUNDRED_PERCENT : false;

  const content = (
    <div
      style={{
        padding: 16,
        minWidth: 520,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        alignItems: "start",
        gap: 24,
      }}
    >
      {/* Header row */}
      <div
        style={{
          gridColumn: "1 / span 1",
          fontWeight: 700,
          fontSize: 14,
          lineHeight: "18px",
          color: "#333",
        }}
      >
        {`${intl.formatMessage({
          id: "LABEL_PACING_AT",
          defaultMessage: "Pacing at",
        })} ${hasPacingAt ? `${pacingAt}%` : "-"}`}
      </div>

      <div
        style={{
          gridColumn: "2 / span 1",
          fontWeight: 700,
          fontSize: 14,
          lineHeight: "18px",
          color: "#333",
          textAlign: "right",
        }}
      >
        {`${intl.formatMessage({
          id: "LABEL_PACING_AMOUNT_OF",
          defaultMessage: "Pacing Amount of",
        })} ${nullishCurrencyFormat(pacingAmount)}`}
      </div>

      {/* Left metric: Spend Yesterday */}
      <div style={{ gridColumn: "1 / span 1" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 6,
            fontWeight: 800,
            letterSpacing: 1,
            textTransform: "uppercase",
            color: "#2F3A4A",
          }}
        >
          <LegendBar
            color={
              !isUndefined(pacingAt) ? getColorIndicator(pacingAt) : undefined
            }
            progress={pacingAt}
          />
          <span>
            {intl.formatMessage({
              id: "LABEL_SPEND_YESTERDAY",
              defaultMessage: "Spend Yesterday",
            })}
          </span>
        </div>
        <div style={{ fontSize: 14, color: "#2F3A4A" }}>
          {nullishCurrencyFormat(spendYesterday)}
        </div>
      </div>

      {/* Right metric: Underspend */}
      <div style={{ gridColumn: "2 / span 1", textAlign: "right" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginBottom: 6,
            fontWeight: 800,
            letterSpacing: 1,
            textTransform: "uppercase",
            color: "#2F3A4A",
          }}
        >
          <LegendPill />
          <span>
            {isUnderspend
              ? intl.formatMessage({
                  id: "LABEL_UNDERSPEND",
                  defaultMessage: "Underspend",
                })
              : intl.formatMessage({
                  id: "LABEL_OVERSPEND",
                  defaultMessage: "Overspend",
                })}
          </span>
        </div>
        <div style={{ fontSize: 14, color: "#2F3A4A" }}>
          {nullishCurrencyFormat(underspend)}
        </div>
      </div>
    </div>
  );

  return (
    <Table.Cell>
      {hasPacingAt ? (
        <Popup
          hoverable
          position="top center"
          mouseEnterDelay={100}
          mouseLeaveDelay={250}
          content={content}
          trigger={
            <span
              style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.625rem",
                }}
              >
                <span>{`${pacingAt}%`}</span>
                <Progress
                  size="tiny"
                  percent={pacingAt}
                  style={{ marginBottom: "0", flex: 1 }}
                  color={getColorIndicator(pacingAt)}
                />
              </span>
              <span>
                {nullishCurrencyFormat(spendYesterday)}/
                {nullishCurrencyFormat(pacingAmount)}
              </span>
            </span>
          }
        />
      ) : (
        "-"
      )}
    </Table.Cell>
  );
};

export default PacingRatioPopup;
